
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

var LoanPage = Vue.extend({})
Vue.component('loan-page', LoanPage)

export default {
  name: 'LoanPage',
  components: {
    XTable,XButton
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      info: {}
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl+'/wechat/loan/getLoanJson/'+this.idArr[0],
      method: 'get'
    }).then((response) => {
      this.info = response.data.data.info;
    }).catch((response) => {
    });
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/finance/loan.vue